import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetNews = createAsyncThunk<AxiosResponse<any, any>, any>(
  "news/toGetNews",
  async (lang) => {
    try {
      const response = await axios.get(`${baseUrlApi}portal/news?lang=${lang}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
